import { useState, Fragment } from 'react'
import { Icon } from '../ui'
import {
  buildNotifications,
  loadReadIds,
  saveReadIds,
  NOTIF_TONE,
  NOTIF_TONE_BG,
  type NotifAction,
} from '../../lib/notifications'

interface NotificationsPanelProps {
  role: 'teacher' | 'admin'
  onClose: () => void
  onAct: (go: NotifAction) => void
  onOpenSettings: () => void
}

export function NotificationsPanel({ role, onClose, onAct, onOpenSettings }: NotificationsPanelProps) {
  const [read, setRead] = useState<Set<string>>(loadReadIds)
  const items = buildNotifications(role).map((n) => ({ ...n, unread: n.unread && !read.has(n.id) }))
  const unread = items.filter((n) => n.unread).length

  function markRead(id: string) {
    setRead((prev) => {
      const n = new Set(prev)
      n.add(id)
      saveReadIds(n)
      return n
    })
  }
  function markAll() {
    setRead((prev) => {
      const n = new Set(prev)
      items.forEach((i) => n.add(i.id))
      saveReadIds(n)
      return n
    })
  }

  const groups = [...new Set(items.map((i) => i.group))]

  return (
    <div className="notif-panel" onMouseDown={(e) => e.stopPropagation()}>
      <div className="notif-head">
        <div className="row center gap8">
          <span className="sec-title">Notifications</span>
          {unread > 0 && <span className="notif-count-pill">{unread} new</span>}
        </div>
        <button className="notif-mark" onClick={markAll} disabled={unread === 0}>
          Mark all read
        </button>
      </div>
      <div className="notif-list">
        {groups.map((g) => (
          <Fragment key={g}>
            <div className="notif-group">{g}</div>
            {items
              .filter((i) => i.group === g)
              .map((n) => (
                <button
                  key={n.id}
                  className={`notif-item${n.unread ? ' unread' : ''}`}
                  onClick={() => {
                    markRead(n.id)
                    onAct(n.go)
                    onClose()
                  }}
                >
                  <span className="notif-ic" style={{ background: NOTIF_TONE_BG[n.tone], color: NOTIF_TONE[n.tone] }}>
                    <Icon name={n.icon} size={17} />
                  </span>
                  <span className="notif-body">
                    <span className="notif-title">{n.title}</span>
                    <span className="notif-sub">{n.body}</span>
                    <span className="notif-time">{n.time}</span>
                  </span>
                  {n.unread && <span className="notif-dot" />}
                </button>
              ))}
          </Fragment>
        ))}
      </div>
      <div className="notif-foot">
        <button
          className="notif-foot-btn"
          onClick={() => {
            onClose()
            onOpenSettings()
          }}
        >
          <Icon name="settings" size={15} /> Notification settings
        </button>
      </div>
    </div>
  )
}
